<!-- 登录 -->
<template>
  <div>
    <!-- pc -->
    <div class="loginin hidden-xs hidden-sm hidden-md">
      <img class="loginin_bg" src="@/assets/images/login/login_logo2.png" alt="" />
      <public-input v-for="(item, idx) in login_ipt_arr" :key="idx" :ipt_obj="item"></public-input>
      <div @click="signin_func" class="btn_group p_text_center p_hand font_18 color_ffffff bg_DC000C border_radius6">{{ $t('login.signin') }}</div>
      <div @click="$router.push('/signUp')" class="hint p_hand font_12 color_8F8F8F p_text_center">
        {{ $t('login.gologin') }}
        <span class="color_DC000C">{{ $t('login.signup') }}</span>
      </div>
      <div @click="$router.push('/reset')" class="hint p_hand font_12 color_8F8F8F p_text_center">
        {{ $t('login.goreset') }}
        <span class="color_DC000C">{{ $t('login.reset') }}</span>
      </div>
    </div>
    <!-- h5 -->
    <div class="loginin_h5 hidden-lg">
      <img class="loginin_bg_h5" src="@/assets/images/login/login_logo2.png" alt="" />
      <public-input type="h5" v-for="(item, idx) in login_ipt_arr" :key="idx" :ipt_obj="item"></public-input>
      <div @click="signin_func" class="btn_group_h5 p_text_center p_hand font_18 color_ffffff bg_DC000C border_radius6">{{ $t('login.signin') }}</div>
      <div @click="$router.push('/signUp')" class="hint p_hand font_12 color_8F8F8F p_text_center">
        {{ $t('login.gologin') }}
        <span class="color_DC000C">{{ $t('login.signup') }}</span>
      </div>
      <div @click="$router.push('/reset')" class="hint p_hand font_12 color_8F8F8F p_text_center">
        {{ $t('login.goreset') }}
        <span class="color_DC000C">{{ $t('login.reset') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { login_loginin } from '@/network/index.js';
export default {
  data() {
    return {
      login_ipt_arr: [
        {
          label: this.$t('login.email'),
          value: '',
          error: '',
          callback: e => {
            if (e) {
              this.login_ipt_arr[0].value = e;
              this.login_ipt_arr[0].error = '';
            } else {
              this.login_ipt_arr[0].error = `${this.login_ipt_arr[0].label} is null`;
            }

            //console.log(e);
          }
        },
        {
          label: this.$t('login.password'),
          value: '',
          error: '',
          callback: e => {
            if (e) {
              this.login_ipt_arr[1].value = e;
              this.login_ipt_arr[1].error = '';
            } else {
              this.login_ipt_arr[1].error = `${this.login_ipt_arr[1].label} is null`;
            }
          }
        }
      ]
    };
  },
  components: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
    signin_func() {
      let arr = [...this.login_ipt_arr];
      arr.forEach(item => {
        if (!item.value) {
          item.error = `${item.label} is null`;
        }
      });
      this.login_ipt_arr = [...arr];
      this.login_api();
    },
    login_api() {
      //登录接口
      let that = this,
        email = this.login_ipt_arr[0].value,
        password = this.login_ipt_arr[1].value;
      if (!email || !password) {
        return;
      }
      const loading = this.$loading({ fullscreen: true });
      login_loginin({
        email,
        password
      }).then(res => {
        if (res.code === '0') {
          let token = res.data.token;
          let user_obj = JSON.stringify(res.data);
          that.$store.commit('login/SET_USER', user_obj);
          that.$store.commit('login/SET_TOKEN', token);
          // 判断是否有上一级页面，如果没有就跳转首页
          that.is_loading = false;
          if (that.$route.query.redirect) {
            that.$router.replace({
              path: that.$route.query.redirect
            });
          } else {
            that.$router.replace({
              path: '/'
            });
          }
        }
        loading.close();
      });
      //=============
      setTimeout(() => {
        loading.close();
      }, 1000);
    }//end login_api
  }
};
</script>

<style scoped="scoped">
.loginin_bg {
  display: block;
  width: 210px;
  height: 210px;
  margin: 0 auto 60px auto;
}
.btn_group {
  width: 390px;
  height: 60px;
  line-height: 60px;
  margin: 30px 0 25px 0;
}
.hint {
  padding: 5px 0;
}
/*  */
.loginin_bg_h5 {
  width: 180px;
  height: 180px;
}
.loginin_bg_h5 {
  display: block;
  width: 180px;
  height: 180px;
  margin: 0 auto 60px auto;
}
.btn_group_h5 {
  width: 315px;
  height: 50px;
  line-height: 50px;
  margin: 0px 0 25px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/children/signin.vue